import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const CORES = {
  verde: "bg-emerald-50 text-emerald-800 border-emerald-300",
  amarelo: "bg-amber-50 text-amber-900 border-amber-300",
  vermelho: "bg-red-50 text-red-800 border-red-300",
  neutro: "bg-slate-50 text-slate-700 border-slate-300",
};
const DOT = { verde: "bg-emerald-500", amarelo: "bg-amber-400", vermelho: "bg-red-500", neutro: "bg-slate-400" };

/** Exibição única da classificação (cadastro e portal usam o mesmo cálculo do backend). */
export const ClassificacaoCard = ({ c, compact = false, testid = "classificacao" }) => {
  if (!c) return null;
  return (
    <div className={`rounded-lg border p-3 ${CORES[c.cor] || CORES.neutro}`} data-testid={testid}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`inline-block w-3 h-3 rounded-full ${DOT[c.cor] || DOT.neutro}`} aria-hidden />
        <b className="text-sm" data-testid={`${testid}-rotulo`}>{c.rotulo}</b>
        {c.analisadas > 0 && <span className="text-[11px] opacity-70">{c.analisadas} parcela{c.analisadas > 1 ? "s" : ""} analisada{c.analisadas > 1 ? "s" : ""}</span>}
      </div>
      <p className="text-xs mt-1" data-testid={`${testid}-motivo`}>{c.motivo}</p>
      {!compact && c.mensagem && <p className="text-xs mt-1 font-medium" data-testid={`${testid}-mensagem`}>{c.mensagem}</p>}
    </div>
  );
};

export const ClassificacaoCliente = ({ clienteId, refreshKey }) => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/clients/${clienteId}/classificacao`).then((r) => setC(r.data)).catch(() => setC(null)); }, [clienteId, refreshKey]);
  return <ClassificacaoCard c={c} compact testid="client-classificacao" />;
};
